export default __webpack_public_path__ + "static/media/wave.ae2ba4b1.png";